import { render, staticRenderFns } from "./InputRadio.vue?vue&type=template&id=627a5307&"
import script from "./InputRadio.vue?vue&type=script&lang=ts&"
export * from "./InputRadio.vue?vue&type=script&lang=ts&"
import style0 from "./InputRadio.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports